const customProps = props => ({
  width: 70,
  height: 70,
  ...props
});

/* eslint-disable import/prefer-default-export */
export const InfoIcon = ({ ...props }) => (
  <svg {...customProps(props)} viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70Z"
      fill="#A9FECC"
    />
    <path
      d="M35.0001 0C22.1856 0 10.9518 6.8871 4.85498 17.2177C23.8792 28.6774 46.1776 35.3952 70.0001 35.5645C70.0001 35.3952 70.0001 35.1694 70.0001 35C70.0001 15.6935 54.3066 0 35.0001 0Z"
      fill="#37DDF3"
    />
    <path
      d="M13.8306 62.8306C19.7015 67.3468 27.0402 70 34.9999 70C45.1612 70 54.2499 65.7097 60.629 58.8226C56.6209 58.4839 52.6128 58.2581 48.4919 58.2581C36.5241 58.2581 24.8951 59.8387 13.8306 62.8306Z"
      fill="#37DDF3"
    />
    <path
      d="M33.3258 17.1785L34.4133 40.2825L35.4989 17.1785C35.5056 17.0308 35.4821 16.8833 35.4299 16.7449C35.3776 16.6066 35.2977 16.4804 35.1951 16.374C35.0924 16.2676 34.9691 16.1833 34.8327 16.1262C34.6964 16.069 34.5498 16.0403 34.4019 16.0417V16.0417C34.2558 16.0431 34.1115 16.0739 33.9776 16.1323C33.8437 16.1907 33.7229 16.2755 33.6225 16.3815C33.522 16.4876 33.444 16.6129 33.393 16.7498C33.3421 16.8867 33.3192 17.0325 33.3258 17.1785V17.1785Z"
      stroke="#3859E3"
      strokeWidth="4.15718"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34.4141 55.4169C33.6647 55.4169 32.9321 55.1946 32.309 54.7783C31.6859 54.3619 31.2002 53.7702 30.9134 53.0778C30.6266 52.3854 30.5516 51.6236 30.6978 50.8886C30.844 50.1536 31.2049 49.4784 31.7348 48.9485C32.2647 48.4186 32.9399 48.0577 33.6749 47.9115C34.4099 47.7653 35.1718 47.8403 35.8641 48.1271C36.5565 48.4139 37.1483 48.8996 37.5646 49.5227C37.981 50.1458 38.2032 50.8784 38.2032 51.6278C38.2032 52.6327 37.804 53.5965 37.0934 54.3071C36.3828 55.0177 35.419 55.4169 34.4141 55.4169Z"
      fill="#3859E3"
    />
  </svg>
);

export const SuccessIcon = ({ ...props }) => (
  <svg {...customProps(props)} viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70Z"
      fill="#A9FECC"
    />
    <path
      d="M35.0006 0C22.1861 0 10.9522 6.8871 4.85547 17.2177C23.8797 28.6774 46.178 35.3952 70.0006 35.5645C70.0006 35.3952 70.0006 35.1694 70.0006 35C70.0006 15.6935 54.3071 0 35.0006 0Z"
      fill="#37DDF3"
    />
    <path
      d="M13.8301 62.8306C19.701 67.3468 27.0398 70 34.9994 70C45.1607 70 54.2494 65.7097 60.6285 58.8226C56.6204 58.4839 52.6123 58.2581 48.4914 58.2581C36.5236 58.2581 24.8946 59.8387 13.8301 62.8306Z"
      fill="#37DDF3"
    />
    <path
      d="M52.25 34C52.25 24.4766 44.5234 16.75 35 16.75C25.4766 16.75 17.75 24.4766 17.75 34C17.75 43.5234 25.4766 51.25 35 51.25C44.5234 51.25 52.25 43.5234 52.25 34Z"
      stroke="#3859E3"
      strokeWidth="3"
      strokeMiterlimit="10"
    />
    <path
      d="M43.625 26.8125L31.55 41.1875L26.375 35.4375"
      stroke="#3859E3"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ErrorIcon = ({ ...props }) => (
  <svg {...customProps(props)} viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70Z"
      fill="#EFB8B8"
    />
    <path
      d="M35.0026 0C22.1881 0 10.9542 6.8871 4.85742 17.2177C23.8816 28.6774 46.18 35.3952 70.0026 35.5645C70.0026 35.3952 70.0026 35.1694 70.0026 35C70.0026 15.6935 54.309 0 35.0026 0Z"
      fill="#F38D8D"
    />
    <path
      d="M13.8301 62.8304C19.701 67.3465 27.0398 69.9997 34.9994 69.9997C45.1607 69.9997 54.2494 65.7094 60.6285 58.8223C56.6204 58.4836 52.6123 58.2578 48.4914 58.2578C36.5236 58.2578 24.8946 59.8385 13.8301 62.8304Z"
      fill="#F38D8D"
    />
    <path
      d="M35 15C23.9451 15 15 23.9459 15 35C15 46.0549 23.9459 55 35 55C46.0549 55 55 46.0541 55 35C55 23.9451 46.0541 15 35 15ZM35 51.875C25.6724 51.875 18.125 44.327 18.125 35C18.125 25.6724 25.673 18.125 35 18.125C44.3276 18.125 51.875 25.673 51.875 35C51.875 44.3276 44.327 51.875 35 51.875Z"
      fill="#CA0101"
    />
    <path
      d="M35 25.0684C34.137 25.0684 33.4375 25.7679 33.4375 26.6309V36.6928C33.4375 37.5558 34.137 38.2553 35 38.2553C35.863 38.2553 36.5625 37.5558 36.5625 36.6928V26.6309C36.5625 25.7679 35.863 25.0684 35 25.0684Z"
      fill="#CA0101"
    />
    <path
      d="M35 44.3877C36.165 44.3877 37.1094 43.4433 37.1094 42.2783C37.1094 41.1133 36.165 40.1689 35 40.1689C33.835 40.1689 32.8906 41.1133 32.8906 42.2783C32.8906 43.4433 33.835 44.3877 35 44.3877Z"
      fill="#CA0101"
    />
  </svg>
);

export const CopyIcon = ({ ...props }) => (
  <svg width={23} height={23} viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.3333 0.958344H3.83334C2.77917 0.958344 1.91667 1.82084 1.91667 2.87501V16.2917H3.83334V2.87501H15.3333V0.958344ZM18.2083 4.79168H7.66667C6.61251 4.79168 5.75001 5.65418 5.75001 6.70834V20.125C5.75001 21.1792 6.61251 22.0417 7.66667 22.0417H18.2083C19.2625 22.0417 20.125 21.1792 20.125 20.125V6.70834C20.125 5.65418 19.2625 4.79168 18.2083 4.79168ZM18.2083 20.125H7.66667V6.70834H18.2083V20.125Z"
      fill="#455775"
    />
  </svg>
);
